import { TailwindPlugin } from '@davincihealthcare/elty-design-system-foundations';
import plugin from 'tailwindcss/plugin';

export const defaultPlugin = plugin(
  ({ addBase }) => {
    // eslint-disable-next-line no-undef
    addBase(require('./style.cjs'));
  },
  {
    plugins: [TailwindPlugin],
  },
);

export const pluginWithoutStyles = plugin(({ addBase }) => {
  // eslint-disable-next-line no-undef
  addBase(require('./style.cjs'));
});
